const ImageIcon = ({ ...props }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M20.5986 4.92651C20.5986 4.0346 19.9237 3.40015 19.1982 3.40015H4.79883C4.07334 3.40015 3.39844 4.0346 3.39844 4.92651V19.074L3.40625 19.238C3.48305 20.0426 4.11871 20.6003 4.79883 20.6003H19.1982C19.9237 20.6003 20.5986 19.9658 20.5986 19.074V4.92651ZM14.0332 7.60034C14.3794 7.61238 14.6943 7.80343 14.8662 8.10425L18.8662 15.1042C19.043 15.4137 19.0422 15.794 18.8633 16.1023C18.6843 16.4104 18.3544 16.6003 17.998 16.6003H5.99805C5.62951 16.6002 5.29119 16.3969 5.11719 16.072C4.94324 15.747 4.96169 15.3525 5.16602 15.0457L8.16602 10.5457L8.2334 10.4558C8.40032 10.2576 8.63958 10.131 8.90039 10.1052C9.19835 10.0759 9.49334 10.1816 9.70508 10.3933L10.8418 11.53L13.166 8.04565L13.2441 7.94312C13.4404 7.71768 13.73 7.5899 14.0332 7.60034ZM11.8301 13.655C11.6639 13.9041 11.3947 14.066 11.0967 14.0955C10.7987 14.1249 10.5028 14.0191 10.291 13.8074L9.15332 12.6697L7.86621 14.6003H16.2754L13.9326 10.5007L11.8301 13.655ZM22.5986 19.074C22.5986 20.9725 21.1237 22.6003 19.1982 22.6003H4.79883C2.93343 22.6003 1.49052 21.0724 1.40234 19.2507L1.39844 19.074V4.92651C1.39844 3.02794 2.87335 1.40015 4.79883 1.40015H19.1982C21.1237 1.40015 22.5986 3.02794 22.5986 4.92651V19.074Z"
        fill="#090914"
      />
    </svg>
  );
};

export default ImageIcon;
